import axios from 'axios';
import { BACKEND_API } from '../utils/config';
export const HTTP = axios.create({
  
    baseURL: BACKEND_API
  })
